module.exports = {
	"classes": [
		"enterprise-page"
	],
	"title": "Enterprise Identity Management",
	"metas": {
		"description": "Let Auth0 handle your Enterprise Authentication, Authorization and Identity Management so you can focus on your business."
	},
	"opengraph": {
		"og:title": "Enterprise Identity Management",
		"og:description": "Let Auth0 handle your Enterprise Authentication, Authorization and Identity Management so you can focus on your business.",
		"og:url": "https://auth0.com/enterprise",
		"og:image": "https://cdn.auth0.com/website/assets/pages/enterprise/img/enterprise-card-2-eb7dd5df38.png",
		"og:image:secure_url": "https://cdn.auth0.com/website/assets/pages/enterprise/img/enterprise-card-2-eb7dd5df38.png"
	},
	"twittercard": {
		"twitter:title": "Enterprise Identity Management",
		"twitter:description": "Let Auth0 handle your Enterprise Authentication, Authorization and Identity Management so you can focus on your business.",
		"twitter:image": [
			{
				"src": "https://cdn.auth0.com/website/assets/pages/enterprise/img/enterprise-card-2-eb7dd5df38.png"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/enterprise/metadata.json
// module id = 1379
// module chunks = 0